import { useEffect, useRef } from "react";

const DatePickerTextField = (props) => {

    const tableBodyRef = useRef();

    useEffect(() => {
        tableBodyRef.current.select()
    }, []);

    return (
        <div className="textfield w-full">
            <div className="textfield-group">
                <input ref={tableBodyRef} className="textfield-input tracking-widest" {...props} />
            </div>
        </div>
    )
};

export default DatePickerTextField;